export enum SidebarView {
  MyOrder = 'myOrder',
  OrderHisory = 'orderHisory',
}
